import styled from 'styled-components';
import {
  openDetailLink,
  openKakaoLink,
  openYoutubeLink,
  openAppDownloadLink,
  tabletQuery,
  isWeb,
} from '../../../utils';
import { ImageUtils } from '../../../utils/ImageUtils';
import { useTextVariant } from '../../../hook/useTextVariant';
import { BOTTOM_SNS_CONSTANTS } from '../../../constants/bottomSns';

export const BottomSnsPc = () => {
  const { getText } = useTextVariant(BOTTOM_SNS_CONSTANTS, false);

  const links = [
    {
      icon: ImageUtils.SnsIcon1,
      text: getText('appDownload'),
      onClick: openAppDownloadLink,
      onlyWeb: true,
    },
    { icon: ImageUtils.SnsIcon2, text: getText('kakaoChannel'), onClick: openKakaoLink },
    { icon: ImageUtils.SnsIcon3, text: getText('youtube'), onClick: openYoutubeLink },
    { icon: ImageUtils.SnsIcon4, text: getText('detail'), onClick: openDetailLink },
  ];

  return (
    <Container>
      <Inner>
        {links.map((link, index) => {
          if (!isWeb() && link.onlyWeb) {
            return null;
          }
          return (
            <Link key={index} onClick={link.onClick}>
              <img src={link.icon} alt="" />
              <LinkText>{link.text}</LinkText>
            </Link>
          );
        })}
      </Inner>
    </Container>
  );
};

const Container = styled.div`
  width: 100%;
  position: fixed;
  bottom: 0;
  z-index: 10;
  left: 0;
  display: flex;
  align-items: center;
  justify-content: center;
`;

const Inner = styled.div`
  display: flex;
  align-items: center;
  justify-content: center;
  padding-left: 37px;
  padding-right: 37px;
  height: 85px;
  background: rgba(64, 64, 64, 0.5);
  box-shadow: 0 -2px 4px 0 rgba(0, 0, 0, 0.1);
  border-top-right-radius: 55px;
  border-top-left-radius: 55px;
  backdrop-filter: blur(25px);
  -webkit-backdrop-filter: blur(25px);

  ${tabletQuery} {
    width: 100%;
    justify-content: space-between;
  }
`;

const Link = styled.div`
  cursor: pointer;
  width: 170px;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  margin-right: 46px;

  &:last-child {
    margin-right: 0;
  }
`;

const LinkText = styled.h4`
  font-weight: 500;
  font-size: 18px;
  line-height: 30px;
  text-align: center;
  letter-spacing: -0.04em;
  color: rgba(255, 255, 255, 0.8);
`;
